/* eslint-disable react/function-component-definition */
/* eslint-disable react/no-unstable-nested-components */
import * as React from 'react';
import { ReactNode } from 'react';
import Card from './Card';
import { HatType } from './Hat';
import '../css/offer-card.sass';
import LinkButton from './LinkButton';
import Popup from './Popup';
import fixRapOnScroll from '../utils/fixRapOnScroll';
import Shoe from './Shoe';

export interface AdditionalDetails {
  label?: string;
  description?: string | React.ReactNode;
}
export interface ActionLinkButton {
  name: string;
  id: string;
  style?: React.CSSProperties;
  focus?: boolean;
  theme?: 'night' | 'day';
  onClick?: Function;
  disabled?: boolean;
  smol?: boolean;
  type?: 'primary' | 'secondary';
}
interface OfferCardProps {
  id: string;
  theme?: 'night' | 'day';
  hat?: HatType[];
  title: string;
  description?: ReactNode;
  children?: ReactNode;
  linkButtons?: ActionLinkButton[];
  rap?: boolean;
  onPopupClose?: Function;
  scrollRAPStopId?: string;
  scrollRAPTriggerId?: string;
  additionalDetails?: AdditionalDetails;
  fixPositionOnScroll?: boolean;
}

export default function OfferCard(props: OfferCardProps) {
  const {
    theme = 'day',
    scrollRAPTriggerId = props.id,
    scrollRAPStopId = 'campfirefooter',
    fixPositionOnScroll = true
  } = props;

  const primaryLinkButton =
    props.linkButtons &&
    props.linkButtons.filter(
      (btn: ActionLinkButton) => btn.type === 'primary'
    )[0];
  const secondaryLinkButton =
    props.linkButtons &&
    props.linkButtons.filter(
      (btn: ActionLinkButton) => btn.type !== 'primary'
    )[0];

  const isMobileView = window.innerWidth < 992;

  const scrollRap = () => {
    if (!isMobileView && props.rap && fixPositionOnScroll) {
      fixRapOnScroll(props.id, scrollRAPStopId, scrollRAPTriggerId);
    }
  };

  React.useEffect(() => {
    scrollRap();
    window.addEventListener('scroll', scrollRap, true);
    return () => window.removeEventListener('scroll', scrollRap, true);
  }, []);

  const OfferCardDetails = () => {
    return (
      <div className={`offer-card ${theme}`} key={props.id} id={props.id}>
        <Card theme={theme} hat={props.hat}>
          <div className="ofr-title">{props.title}</div>
          {props.description && (
            <div className="ofr-description">{props.description}</div>
          )}
          {props.children}
          {props.linkButtons && (
            <div className="ofr-buttons">
              {primaryLinkButton && (
                <span className="primaryLink">
                  <LinkButton
                    {...primaryLinkButton}
                    name={primaryLinkButton.name}
                    id={primaryLinkButton.id}
                    smol
                    onClick={(e: any) => {
                      if (primaryLinkButton.onClick !== undefined) {
                        primaryLinkButton.onClick(e);
                      }
                    }}
                  >
                    {primaryLinkButton.name}
                  </LinkButton>
                </span>
              )}
              {secondaryLinkButton && (
                <span>
                  <LinkButton
                    {...secondaryLinkButton}
                    name={secondaryLinkButton.name}
                    id={secondaryLinkButton.id}
                    smol
                    type={secondaryLinkButton.type}
                    onClick={(e: any) => {
                      if (secondaryLinkButton.onClick !== undefined) {
                        secondaryLinkButton.onClick(e);
                      }
                    }}
                  >
                    {secondaryLinkButton.name}
                  </LinkButton>
                </span>
              )}
            </div>
          )}
        </Card>
        {props.additionalDetails && (
          <div className="additional-details">
            <Shoe theme={theme}>
              <div className="label">{props.additionalDetails.label}</div>
              <div className="description">
                {props.additionalDetails.description}
              </div>
            </Shoe>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {isMobileView && props.rap ? (
        <Popup
          onClose={() => {
            if (props.onPopupClose) {
              props.onPopupClose();
            }
          }}
          modal
          width="inherit"
          position="center"
          displayCloseButton
          takeover
        >
          {OfferCardDetails()}
        </Popup>
      ) : (
        <>{OfferCardDetails()}</>
      )}
    </>
  );
}
